export const styles = {
  upsellContainer: {
    backgroundColor: "background.paper",
    padding: 2.5,
    border: "1px solid rgba(234, 238, 242, 1)",
    borderRadius: "5px",
  },
  upsellHeader: {
    marginBottom: 1.25,
  },
  upsellButton: {
    color: "white",
    textDecoration: "none",
  },
  helpText: {
    marginBottom: 2,
  },
};
